// filepath: c:\Users\Laptop\Desktop\studio-kosmos-admin\src\utils\constants.js
import React from "react";
import { Users, Edit, Eye } from "lucide-react";

// Keep the same structure but centralize for reuse
export const ALL_PERMISSIONS = [
  { 
    key: "dashboard", 
    label: "Dashboard", 
    description: "Access to analytics and performance overview",
    icon: <Eye size={18} />
  },
  { 
    key: "bookings", 
    label: "Bookings Management",
    description: "Manage customer appointments and scheduling",
    icon: <Eye size={18} />
  },
  {
    key: "sessions",
    label: "Session Calendar",
    description: "View and manage studio sessions",
    icon: <Eye size={18} />
  },
  { 
    key: "users", 
    label: "User Management",
    description: "Manage customer accounts and profiles",
    icon: <Users size={18} />
  },
  { 
    key: "services", 
    label: "Service Management",
    description: "Create and edit service offerings",
    icon: <Eye size={18} />
  },
  { 
    key: "homepage", 
    label: "Homepage Editor",
    description: "Edit main website content and appearance",
    icon: <Edit size={18} />
  },
  {
    key: "studio-assistant",
    label: "AI Assistant",
    description: "Use the studio AI assistant",
    icon: <Eye size={18} />
  },
  {
    key: "privacy-terms",
    label: "Privacy & Terms",
    description: "Edit privacy and terms content",
    icon: <Edit size={18} />
  },
  { 
    key: "portfolio", 
    label: "Portfolio Management",
    description: "Manage project showcases and galleries",
    icon: <Eye size={18} />
  },
];

export const ROLE_TEMPLATES = {
  Superadmin: {
    description: "Full access to all admin features and user management",
    permissions: [
      "dashboard", "bookings", "users", "services", "homepage", "portfolio"
    ],
    isProtected: true,
  },
  "Website Editor": {
    description: "Modify the website's visual elements and content",
    permissions: ["homepage", "portfolio"],
  },
  "Bookings Manager": {
    description: "Manage all client appointments and scheduling",
    permissions: ["dashboard", "bookings"],
  },
  "Service Manager": {
    description: "Manage services, packages and offerings",
    permissions: ["services"],
  },
  "Content Manager": {
    description: "Manage website content and portfolio",
    permissions: ["homepage", "portfolio"],
  },
  "Limited Admin": {
    description: "View-only access to basic information",
    permissions: ["dashboard"],
  },
  "Full Admin": {
    description: "Full platform access",
    permissions: [
      "dashboard",
      "bookings",
      "users",
      "services",
      "homepage",
      "portfolio",
    ],
  },
};